<template>
  <div :class="$style.field">
    <label :for="id">
      {{ entity.label }}
      <i v-if="required">*</i>
    </label>
    <flat-pickr
      :id="id"
      :disabled="readonly"
      v-model="value"
      :placeholder="entity.description"
      :name="name"
      :required="required"
      :config="config"
    ></flat-pickr>
    <p v-show="error && showError">{{ error }}</p>
  </div>
</template>

<script>
import Field from "./field";
import { getWeekStartByLocale } from "weekstart";
import FlatPickr from "vue-flatpickr-component";

export default {
  mixins: [Field],
  components: { FlatPickr },
  data() {
    return {
      config: {
        minDate: "today",
        altInput: true,
        altFormat: "F j, Y H:i",
        enableTime: true,
        time_24hr: true,
        dateFormat: "Z",
        locale: {
          firstDayOfWeek: getWeekStartByLocale(navigator.language),
        },
      },
    };
  },
  mounted() {
    const el = this.$el.querySelector(".form-control:not([type=hidden])");

    if (el) {
      el.classList.remove("form-control");
    }
  },
  methods: {
    typecast(value) {
      // remove miliseconds from datetime field
      return value ? `${value.split(".")[0]}Z` : null;
    },
  },
};
</script>

<style lang="stylus" src="./datetime-field.styl"></style>
<style module lang="less" src="./field.less"></style>



// WEBPACK FOOTER //
// datetime-field.vue?aa97bfd4